<template>
  <div class="container" ref="box">
    <el-card class="card">
      <img class="logoImg" src="@/assets/imgs/logo_index.png" alt="" />
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        status-icon
      >
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            placeholder="请输入账号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="loginForm.password"
            autocomplete="off"
            placeholder="请输入密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-row>
            <el-col :span="13">
              <el-input
                v-model="loginForm.code"
                placeholder="请输入图片验证码"
              ></el-input>
            </el-col>
            <el-col :span="10">
              <!-- <img class="codeImg" :src="require('@/assets/imgs/'+this.captchaImage)" alt="" @click="changeCode"/> -->
              <img class="codeImg" :src="this.captchaImage" alt="" @click="changeCode"/>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-button
            @click="login('loginForm')"
            type="primary"
            style="width: 100%"
            >登 录</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
    <a class="recordNumber" href="https://beian.mps.gov.cn/#/query/webSearch?code=37030302001012" rel="noreferrer" target="_blank">
      <img style="width: 20px; height: 20px; vertical-align:bottom" src="@/assets/imgs/filingsLogo.png" alt="">
      鲁公网安备37030302001012
    </a>
    <a class="recordNumber1" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">鲁ICP备20028203号-2 &nbsp;&nbsp;|</a>
  </div>
</template>

<script>
import { captchaImage , login} from "@/api/login"
import { workShops} from "@/api/wormBox"
import { setUser , setTitle } from '@/utils/auth'
import { jumpModelBtn } from "@/utils/control"
import { mapMutations } from "vuex";
export default {
  data() {
    var validateCode = (rule, value, callback) => {
      if (this.loginForm.code == "") {
        callback(new Error("请输入图片验证码"));
      }
    };
    return {
      // 表单数据对象
      captchaImage:"",
      loginForm: {
        username: "",
        password: "",
        code: "",
        uuid:""
      },
      // 表单校验规则对象
      loginRules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ],
        // code: [{ validator: validateCode, trigger: "blur" }],
      },
    };
  },
  methods: {
    ...mapMutations(["setIsContainHomePage"]),
    login(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          const data = await login(this.loginForm)
          if( data != undefined && data.code == "200"){
            setUser({token:data.resultData.token})
            const workShopsList = await workShops()
            if(workShopsList. resultData != null && workShopsList.code == "200"){
              if(workShopsList.resultData.length > 1){
                setTitle({title:serveConfig.title})
                this.$router.push("/plant")
              }else if(workShopsList.resultData.length == 1){
                setTitle({title:workShopsList.resultData[0].workShopName})
                if(workShopsList.resultData[0].roleModelList[0].modelEnName == "HOME"){
                  this.setIsContainHomePage(true)
                  this.$router.push({path:`/${workShopsList.resultData[0].workShopEnName}`,query:{homePage:workShopsList.resultData[0].workShopEnName,index:0}})
                }else{
                  this.setIsContainHomePage(false)
                  jumpModelBtn(workShopsList.resultData[0].roleModelList[0].modelUrl,workShopsList.resultData[0].roleModelList[0].modelFullName,0,workShopsList.resultData[0].workShopEnName)
                }
              }else{
                this.$message.error('请检查工厂列表')
              }
            }
          }else{
            this.changeCode()
          }
        } else {
          this.$message.error('填写错误，请检查')
        }
      });
    },
    async changeCode(){
      const data = await captchaImage()
      if(data != undefined && data.code == "200"){
        this.loginForm.uuid = data.resultData.uuid
        this.captchaImage =`data:image/jpg;base64,${data.resultData.img}`
      } 
    }
  },
  created(){
    this.changeCode()
  }
};
</script>

<style scoped lang='less'>
.container {
  background: url(~@/assets/imgs/login.jpg) no-repeat center / cover;
  width: 1920px;
  height: 1080px;
  .card {
    width: 450px;
    height: 400px;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin-right: 200px;
    .logoImg {
      width: 200px;
      display: block;
      margin: 0 auto 20px;
    }
    /deep/.el-input {
      height: 50px;
      font-size: 20px;
    }
    /deep/.el-input__inner{
      height: 50px;
    }
    .codeImg {
      width: 170px;
      height: 50px;
      padding-left: 10px;
    }
  }
  .recordNumber{
    color: #FFFFFF;
    text-decoration: none;
    position: absolute;
    bottom: 10px;
    left: 950px;
  }:hover{
    color: #1264ec;
  }
  .recordNumber1{
    color: #FFFFFF;
    text-decoration: none;
    position: absolute;
    bottom: 10px;
    left: 750px;
  }:hover{
    color: #1264ec;
  }
}
</style>